import "core-js/modules/es.array.concat.js";
import React from 'react';
import PropTypes from 'prop-types';
import { list, horizontalMargin } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AvailableFundsValuesList = function AvailableFundsValuesList(_ref) {
  var _data$total_balance, _data$commission_repo, _data$available_balan, _data$total_collected, _data$total_collected2, _data$total_collected3;

  var data = _ref.data,
      currency = _ref.currency;
  return ___EmotionJSX("div", {
    css: horizontalMargin
  }, ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-group "
  }, ___EmotionJSX("h6", {
    className: "list-title "
  }, "\u0422\u043E\u0442\u0430\u043B"), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_data$total_balance = data === null || data === void 0 ? void 0 : data.total_balance) !== null && _data$total_balance !== void 0 ? _data$total_balance : '--', " ").concat(currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u043B\u0438\u0445\u0432\u0438 \u0438 \u0442\u0430\u043A\u0441\u0438"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_data$commission_repo = data === null || data === void 0 ? void 0 : data.commission_report_balance) !== null && _data$commission_repo !== void 0 ? _data$commission_repo : '--', " ").concat(currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041D\u0430\u043B\u0438\u0447\u043D\u0438 \u0437\u0430 \u0440\u0430\u0437\u0434\u0430\u0432\u0430\u043D\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_data$available_balan = data === null || data === void 0 ? void 0 : data.available_balance) !== null && _data$available_balan !== void 0 ? _data$available_balan : '--', " ").concat(currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E \u0441\u044A\u0431\u0440\u0430\u043D\u0438 \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0438"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_data$total_collected = data === null || data === void 0 ? void 0 : data.total_collected_principals) !== null && _data$total_collected !== void 0 ? _data$total_collected : '--', " ").concat(currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E \u0441\u044A\u0431\u0440\u0430\u043D\u0438 \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_data$total_collected2 = data === null || data === void 0 ? void 0 : data.total_collected_interests) !== null && _data$total_collected2 !== void 0 ? _data$total_collected2 : '--', " ").concat(currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E \u0441\u044A\u0431\u0440\u0430\u043D\u0438 \u0442\u0430\u043A\u0441\u0438"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_data$total_collected3 = data === null || data === void 0 ? void 0 : data.total_collected_fees) !== null && _data$total_collected3 !== void 0 ? _data$total_collected3 : '--', " ").concat(currency))))));
};

AvailableFundsValuesList.propTypes = {
  data: PropTypes.object,
  currency: PropTypes.string
};
export default AvailableFundsValuesList;